import React from 'react';
import ListingsContainer from './listingsContainer';

function Listing() {
  return <ListingsContainer />;
}

export default Listing;
